import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/HomePage';
import Portfolio from './components/Portfolio';
import Services from './components/Services';
import ScrollToTop from './components/ScrollToTop';
import Contact from './components/Contact';
import Datenschutz from './components/Datenshutz';

function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className="App">
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path="/usluge" element={<Services />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />


                </Routes>
            </div>
        </Router>
    );
}

export default App;